import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthStore2 } from '../store/auth.store';

export const checkInGuestGuard: CanMatchFn = (route, segments) => {
  const authStore = inject(AuthStore2);
  const router = inject(Router);

  if (!authStore.isAuthenticated()) {
    return true;
  }

  /* TODO: replace with scanner.home to avoid hardcoding */
  return router.parseUrl('/scanner');
};
